<template>
    <div class="modal fade" id="detailsRankingCriteriaModal" role="dialog" aria-labelledby="detailsRankingCriteriaLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="detailsRankingCriteriaModal">{{$t('rankingCriteria.details')}}</h5>
                    <button v-if="showCloseBtn" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <RankingCriteriaEditCard v-model="model"
                                             v-if="showEditor"
                                             :createNew="false"
                                             :readonly="true"
                                             @cancel="onCancel">
                    </RankingCriteriaEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { RankingCriteria } from '../../models/models';
    import RankingCriteriaEditCard from './RankingCriteriaEditCard';

    export default {
        components: {
            RankingCriteriaEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
            showCloseBtn: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                showEditor: false,
                model: new RankingCriteria(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new RankingCriteria();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new RankingCriteria(this.value);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
